'use client';

import { type FC } from 'react';
import type { FighterInit, RoundEvent } from '@cs-shot/battle-sim';
import { BottomSheet } from '../../ui';
import { MatchLog } from './MatchLog';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';

/** Лог прошедших раундов текущего матча — открывается из боя в decision-окно. */
export const RoundLogSheet: FC<{
  isOpen: boolean; onClose: () => void; inits: FighterInit[]; rounds: RoundEvent[][];
}> = ({ isOpen, onClose, inits, rounds }) => {
  const { t } = useLocalTranslation(translations);
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('roundLogTitle')} heightClass="h-[70vh]">
      <div className="h-full overflow-y-auto px-4 pb-6">
        {rounds.length
          ? <MatchLog inits={inits} rounds={rounds} />
          : <div className="text-sm text-label-secondary">{t('roundLogEmpty')}</div>}
      </div>
    </BottomSheet>
  );
};
